export const canViewDemoPoint = (userData) => Boolean(userData?.isUserCenterPartner);

export const canViewIntelligenceReports = (userData) =>
  Boolean(userData?.isCpEmployee || userData?.isCpSales || userData?.isUserCenterPartner);
